import { useQuery } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';
import { SchemaYellowHiveProduct } from 'wg-api-sdk';

const getYellowhiveProductById = async (
  productId: string,
): Promise<SchemaYellowHiveProduct> => {
  const { data, isError } = await wgApi.get<SchemaYellowHiveProduct>(
    `/v1/api/yellowhiveflows/products/${productId}`,
  );

  if (isError) throw new Error('Failed to fetch product');
  return data;
};

export const getUseYellowhiveProductByIdQKey = (productId: string) => [
  'flow-config',
  'yellowhive',
  'product',
  productId,
];

export const useYellowhiveProductById = (productId: string) => {
  return useQuery(
    getUseYellowhiveProductByIdQKey(productId),
    () => getYellowhiveProductById(productId),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: !!productId,
      retry: 1,
      onError: (error) => {
        console.error('Failed to fetch Yellowhive product:', error);
      },
    },
  );
};
